import { adminSaga } from "react-admin";
import { all, fork } from "redux-saga/effects";

import {
  watchChatNotification,
  watchGetChatRooms,
  watchGetRoomMessages,
  watchLoadMoreRoomMessages,
  watchMarkRoomAsSeen,
} from "../../pages/Chat/sagas";
import watchGetEnums from "./syncEnums";
import watchGetSettings from "./syncSettings";
import syncUser from "./syncUser";
import { watchFetchNotifications } from "../../shared/BaseNotificationList";

const sagas = (dataProvider: any, authProvider: any) =>
  function* rootSaga() {
    try {
      yield all(
        [
          adminSaga(dataProvider, authProvider),
          syncUser,
          watchGetEnums,
          watchChatNotification,
          watchGetChatRooms,
          watchGetRoomMessages,
          watchMarkRoomAsSeen,
          watchLoadMoreRoomMessages,
          watchGetSettings,
          watchFetchNotifications,
        ].map(fork)
      );
    } catch (ex: any) {
      console.log(ex.message);
    }
  };

export default sagas;
